function trimStringWithEllipsis(str) {
    const maxLength = 123
    if (str.length > maxLength) {
        return str.slice(0, maxLength) + '...'
    }
    return str
}

export default trimStringWithEllipsis
